// extracted by mini-css-extract-plugin
export var alertIcon = "_tn-0";